import { defineNuxtPlugin, useRuntimeConfig } from '#app'

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()

    return {
        provide: {
            game: config.public.game || {},
        },
    }
})
